import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { Product } from '../products/product';
import { CartItem } from '../cart/cart-item';
import { LoggingService } from '../loging/logging.service';
export class CartService {

    cartItems: CartItem[] = [];
    observableCartItems: BehaviorSubject<CartItem[]> = new BehaviorSubject<CartItem[]>(this.cartItems);
    observableTotalBeforeTax: Observable<number> =
    this.observableCartItems.asObservable()
        .map((cartItems: CartItem[]) => this.totalBeforeTax(cartItems));
/**
 * @param {?} loggingService
 */
constructor(private loggingService: LoggingService) {

        this.cartItems = [];

    }
/**
 * @param {?} product
 * @return {?}
 */
add(product: Product) {
        //this.loggingService.log('cart.service.ts.add: this.cartItems = ' + JSON.stringify(this.cartItems));

        // this.loggingService.log('searcing for cartItem.product = ' + JSON.stringify(product));
        // let testNumber = 0;
        let /** @type {?} */ cartItem = this.cartItems.find((testCartItem) => {
            // testNumber++;
            // this.loggingService.log('testCartItem' + testNumber);
            return testCartItem.product === product;
        });

        if (cartItem) {
            cartItem.quantity++;
            // this.loggingService.log('found cartItem, quantity incremented to = ' + cartItem.quantity);
        } else {
            // this.loggingService.log('no cartItem found. creating a new one');
            cartItem = new CartItem();
            cartItem.product = product;
            cartItem.quantity = 1;
            cartItem.index = this.cartItems.length;
            this.cartItems.push(cartItem);
        }

        this.observableCartItems.next(this.cartItems);

    }
/**
 * @param {?} index
 * @return {?}
 */
increaseQuantity(index: number) {
        if (index > -1) {
            let /** @type {?} */ cartItem = this.cartItems[index];

            cartItem.quantity++;
        }

        this.observableCartItems.next(this.cartItems);
    }
/**
 * @param {?} index
 * @return {?}
 */
decreaseQuantity(index: number) {

        if (index > -1) {
            let /** @type {?} */ cartItem = this.cartItems[index];

            if (cartItem.quantity === 1) {
                this.cartItems.splice(index, 1);

                for (let /** @type {?} */ i = index; i < this.cartItems.length; i++) {
                    this.cartItems[i].index = i;
                }
            } else {
                cartItem.quantity--;
            }
        }

        this.observableCartItems.next(this.cartItems);
    }
/**
 * @return {?}
 */
clear() {

        this.cartItems = [];

        this.observableCartItems.next(this.cartItems);
    }
/**
 * @return {?}
 */
get() {
        return this.cartItems;

    }
/**
 * @return {?}
 */
getTotalBeforeTax() {
        let /** @type {?} */ totalBeforeTax = 0;
        for (let /** @type {?} */ index = 0; index < this.cartItems.length; index++) {
            totalBeforeTax += this.cartItems[index].quantity * parseFloat(this.cartItems[index].product.price);
        }

        return Math.round(totalBeforeTax * 100) / 100;
    }
/**
 * @param {?} cartItems
 * @return {?}
 */
totalBeforeTax(cartItems: CartItem[]) {
        let /** @type {?} */ totalBeforeTax = 0;
        for (let /** @type {?} */ index = 0; index < cartItems.length; index++) {
            totalBeforeTax += cartItems[index].quantity * parseFloat(cartItems[index].product.price);
        }

        return totalBeforeTax;
    }
/**
 * @return {?}
 */
numberOfItems() {
        let /** @type {?} */ count = 0;

        for (let /** @type {?} */ item of this.cartItems) {
            count += item.quantity;
        }

        return count;
    }

static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: LoggingService, },
];
}

function CartService_tsickle_Closure_declarations() {
/** @type {?} */
CartService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CartService.ctorParameters;
/** @type {?} */
CartService.prototype.cartItems;
/** @type {?} */
CartService.prototype.observableCartItems;
/** @type {?} */
CartService.prototype.observableTotalBeforeTax;
/** @type {?} */
CartService.prototype.loggingService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
